import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <CFLink
              href="https://maps.app.goo.gl/iAwPenAowUtSKrFu5"
              target="_blank"
            >
              <CFImage src={mobileMap} w="100%" alt="Blue House Map" />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              href="https://maps.app.goo.gl/iAwPenAowUtSKrFu5"
              target="_blank"
            >
              <CFImage
                src={locationMap}
                w="100%"
                alt="Blue House Map"
                mt="-2px"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
